import { PERMISSIONS_OPTIONS_VALUE } from 'constants/team-members';

const { EDITOR, VIEW_ONLY } = PERMISSIONS_OPTIONS_VALUE;

export const DISCOUNTS_PERMISSIONS = {
  [VIEW_ONLY]: {
    HIDE_CREATE_DISCOUNT: true,
    HIDE_ACTIONS_MENU: true
  },
  [EDITOR]: {
    HIDE_DEACTIVATE_DISCOUNT: true,
    HIDE_ACTIVATE_DISCOUNT: true,
    HIDE_DELETE_DISCOUNT: true
  }
};
